import { CapacityStatusResponse } from '@api/response/CapacityResponse';
import { HeaderTypes, HttpClientHelper, PTVNClient } from '@ptvn-react/authentication';
import APIConstant from '@utils/constants/APIConstant';
import { AxiosRequestConfig } from 'axios';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class CapacityClient {
  public static getCapacityStatus(): Observable<CapacityStatusResponse> {
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(HeaderTypes.SSO_TOKEN);
    return PTVNClient.get<CapacityStatusResponse>(APIConstant.config.getCapacityStatus, options).pipe(
      map((response) => response.data)
    );
  }
}
